import { useContext } from 'react';
import get from 'lodash/get';
import { DeviationTypes, DeviationResourceType } from '../../types/deviation';
import { getDeviationType, getDeviationResourceType, isSimpleDeviation, isTextualDeviation, getCanHavePremiumDownload, } from '../_helpers';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isExtendedDeviationFullyLoaded } from '../../DeviationPage/redux/helpers';
function getIsEditable(deviation, isMobile) {
    var deviationType = getDeviationType(deviation);
    var canUserEdit = get(deviation, 'extended.canUserEdit', false);
    switch (deviationType) {
        case DeviationTypes.LITERATURE:
        case DeviationTypes.JOURNAL:
            // on mobile, draftjs based lit/journal is not editable
            if (isMobile && get(deviation, 'textContent.html.type') === 'draft') {
                return false;
            }
            return canUserEdit;
        default:
            return canUserEdit;
    }
}
export function useDeviationAttributes(deviation, isOwner) {
    var _a, _b, _c, _d;
    var showMatureContent = useContext(MatureContext);
    var isMobile = useContext(MobileContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var resourceType = getDeviationResourceType(deviation);
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isSimple = isSimpleDeviation(deviation);
    var isText = isSimple || isTextualDeviation(deviation);
    var isReportable = !isOwner && !isSimple;
    var isShareable = deviation.isShareable || isSimple;
    var isGroupSubmittable = !isSimple &&
        (isExtendedLoaded ? !!((_a = deviation.extended) === null || _a === void 0 ? void 0 : _a.canUserAddToGroup) : isLoggedIn);
    var isDeletable = isExtendedLoaded
        ? !!((_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.canUserDelete)
        : isOwner;
    var isPopupPrintPurchasable = ((_c = deviation.print) === null || _c === void 0 ? void 0 : _c.isPopupStore) || false;
    var hasMoreActions = (isShareable || isReportable);
    var hasNft = deviation.hasNft || false;
    return {
        hasFlag: !!deviation.dailyDeviation,
        hasMoreActions: hasMoreActions,
        isCommentable: !!deviation.isCommentable,
        isFavouritable: !isSimple && !isOwner,
        isGroupSubmittable: isGroupSubmittable,
        isDownloadable: !!deviation.isDownloadable,
        isPurchasable: !!deviation.isPurchasable,
        isShareable: isShareable,
        isReportable: isReportable,
        isPrintPurchasable: !!deviation.printId &&
            (!deviation.isMature || showMatureContent === true) &&
            !isText &&
            !isPopupPrintPurchasable,
        isPopupPrintPurchasable: isPopupPrintPurchasable,
        canHavePremiumDownload: getCanHavePremiumDownload(deviation),
        isEditable: getIsEditable(deviation, isMobile === true),
        isDeletable: isDeletable,
        isBackgroundEditable: !!deviation.isBackgroundEditable,
        isAuthorCommissionable: ((_d = deviation.author) === null || _d === void 0 ? void 0 : _d.type) !== 'banned',
        isCoreBadgeAwardable: !isOwner && resourceType === DeviationResourceType.ART,
        isAssetPurchasable: deviation.isAssetPurchasable || false,
        isExtendedLoaded: isExtendedLoaded,
        hasNft: hasNft,
    };
}
//# sourceMappingURL=useDeviationAttributes.js.map